var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAmex = function SvgAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#26A6D1",
    d: "M2.998.838H37.97a2.5 2.5 0 0 1 2.498 2.5v23.73a2.5 2.5 0 0 1-2.498 2.498H2.998A2.5 2.5 0 0 1 .5 27.068V3.338a2.5 2.5 0 0 1 2.498-2.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m6.945 10.831-3.947 8.735h4.725l.586-1.393h1.339l.585 1.393h5.201v-1.063l.464 1.063h2.69l.463-1.086v1.086h10.817l1.315-1.357 1.231 1.357 5.556.01-3.96-4.353 3.96-4.392H32.5l-1.28 1.332-1.193-1.332H18.261l-1.01 2.255-1.035-2.255h-4.715v1.027l-.524-1.027zm.914 1.24h2.303l2.618 5.923v-5.922h2.523l2.022 4.246 1.864-4.246h2.51v6.267h-1.527l-.013-4.911-2.227 4.911h-1.366l-2.24-4.911v4.911h-3.142l-.596-1.405H7.37l-.594 1.404H5.09zm15.238 0h6.21l1.9 2.053 1.962-2.052h1.9l-2.887 3.15 2.886 3.113h-1.986l-1.9-2.076-1.97 2.076h-6.115zM8.979 13.133l-1.06 2.503h2.12zm15.652.237v1.145h3.388v1.275h-3.388v1.249h3.8l1.766-1.84-1.69-1.83z"
  })));
};
export default SvgAmex;